export default class PerfilConstants {
  public static readonly TAB_LISTA = [
    {
      id: '1',
      name: 'Ativas',
      width: '20%',
      icon: 'pi pi-check-circle'
    },
    {
      id: '4',
      name: 'Encerradas',
      width: '20%',
      icon: 'pi pi-briefcase'
    },
    {
      id: '3',
      name: 'Negadas',
      width: '20%',
      icon: 'pi pi-times-circle'
    },
    {
      id: '2',
      name: 'Parcialmente Aceitas',
      width: '20%',
      icon: 'pi pi-folder-open'
    },
    {
      id: '5',
      name: 'Salvas',
      width: '20%',
      icon: 'pi pi-check-circle'
    }
  ]
}
